// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./sass/_Pager.scss
// module id = 637
// module chunks = 16 88